import React from 'react';

const CompanyRequestIcon = ({ className }) => (
    <svg
        width='56'
        height='56'
        viewBox='0 0 56 56'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <rect x='4' y='4' width='48' height='48' rx='24' fill='#F2F4F7' />
        <rect x='4' y='4' width='48' height='48' rx='24' stroke='#F9FAFB' strokeWidth='8' />
        <path
            d='M29 18L19 30H28L27 38L37 26H28L29 18Z'
            stroke='#475467'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export { CompanyRequestIcon };
